import React, { FunctionComponent } from 'react';
import ReactModal from 'react-modal';
import styled from 'styled-components';

import { Loader, Heading } from './chroma';

const HeadingWrapper = styled.div`
  h2 {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
`;

interface ModalProps {
  isOpen: boolean;
  label?: string;
}

export const LoaderModal: FunctionComponent<ModalProps> = ({
  isOpen,
  label,
}) => (
  <ReactModal
    isOpen={isOpen}
    style={{
      content: {
        top: '15%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%)',
        width: '40rem',
        height: '15rem',
        background: 'none',
        border: 'none',
        textAlign: 'center',
      },
      overlay: {
        backgroundColor: 'rgba(255, 255, 255, .6)',
        zIndex: 1000,
      },
    }}
    ariaHideApp={false}
  >
    <Loader />
    {label && (
      <HeadingWrapper>
        <Heading size={2} margin={{ top: 20 }}>
          {label}
        </Heading>
      </HeadingWrapper>
    )}
  </ReactModal>
);

export default LoaderModal;
